import { render, staticRenderFns } from "./MaintenanceRule.vue?vue&type=template&id=24c689a7&scoped=true"
import script from "./MaintenanceRule.vue?vue&type=script&setup=true&lang=js"
export * from "./MaintenanceRule.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MaintenanceRule.vue?vue&type=style&index=0&id=24c689a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c689a7",
  null
  
)

export default component.exports